import { render } from "./KeyWordsView.vue?vue&type=template&id=95d16f3a&ts=true"
import script from "./KeyWordsView.vue?vue&type=script&lang=ts"
export * from "./KeyWordsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__